export default __webpack_public_path__ + "fd1f93511b5cef934744344f8c731727.png";